import React, { useEffect, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import Card from "../../../components/Card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { ROUTES, USER_ROLES , MODULE_ACL} from '../../../utilities/constant';
import { exportToCSV, hasPermission } from '../../../utilities/helpers';
// ✅ API imports
import { API_MANAGE_DIALER_LISTING, API_MANAGE_DIALER_DELETE } from "../../../service/url";
import { getApiCall } from "../../../service/getApiCall";
import { postApiCall } from "../../../service/postApiCall";
import { getUser } from "../../../utilities/setting";
import exportData from '../../../utilities/export';
import Loader  from '../../../components/partials/components/loader';
import { toast } from 'react-toastify';

const DialerListing = () => {
    const [dialers, setDialers] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [selectedDialers, setSelectedDialers] = useState([]);
    const [rows, setRows] = useState(10);
    const [loading, setLoading] = useState(false);

    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [dialerToDelete, setDialerToDelete] = useState(null);
    const [bulkDeleteMode, setBulkDeleteMode] = useState(false);
    const [isSuperAdmin, checkIsSuperAdmin] = useState(false);
    const [moduleOperations, setModuleOperations] = useState({});

    const navigate = useNavigate();



    const fetchDialers = async () => {
        setLoading(true);
        try {
            const response = await getApiCall(API_MANAGE_DIALER_LISTING, {});
            setDialers(response || []);
        } catch (error) {
            console.error("Error fetching dialers:", error);
            setDialers([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
              const user = getUser();
                if (user) {
                  if (user.role === USER_ROLES.SUPERADMIN) {
                    checkIsSuperAdmin(true);
                  }
                  if (user?.acl_settings) {
                    setModuleOperations(JSON.parse(user.acl_settings.module_operations));
                  }
                }
            }, []);

    useEffect(() => {
        fetchDialers();
    }, []);

    // ✅ Filtered data
    const filteredDialers = dialers.filter((d) =>
        d?.dialer_name?.toLowerCase().includes(searchValue.toLowerCase())
    );

    // ✅ Checkbox toggle
    const handleCheckboxToggle = (id) => {
        const isSelected = selectedDialers.includes(id);
        setSelectedDialers(
            isSelected
                ? selectedDialers.filter((i) => i !== id)
                : [...selectedDialers, id]
        );
    };

    const handleSelectAll = () => {
        if (selectedDialers.length === dialers.length) {
            setSelectedDialers([]);
        } else {
            setSelectedDialers(dialers.map((d) => d.dialer_id));
        }
    };

    // ✅ Delete
    const confirmDelete = (id) => {
        setDialerToDelete(id);
        setBulkDeleteMode(false);
        setDeleteModalVisible(true);
    };

    const confirmBulkDelete = () => {
        setBulkDeleteMode(true);
        setDeleteModalVisible(true);
    };

    const executeDelete = async () => {
        try {
            if (bulkDeleteMode) {
                const response = await Promise.all(
                    selectedDialers.map((id) =>
                        postApiCall(API_MANAGE_DIALER_DELETE, { id })
                    )
                );

                if (response) {
                    toast.success("Selected PBX(s) deleted successfully");
                }
                setDialers(dialers.filter((d) => !selectedDialers.includes(d.dialer_id)));
                setSelectedDialers([]);
            } else {
                const response = await postApiCall(API_MANAGE_DIALER_DELETE, { id: dialerToDelete });
                if (response) {
                    toast.success("PBX deleted successfully");
                }
                setDialers(dialers.filter((d) => d.dialer_id !== dialerToDelete));
                setSelectedDialers(selectedDialers.filter((id) => id !== dialerToDelete));
            }
        } catch (error) {
            console.error("Error deleting dialer(s):", error);
        } finally {
            setDeleteModalVisible(false);
            setDialerToDelete(null);
            setBulkDeleteMode(false);
            await fetchDialers();
        }
    };

    const [moduleOperationsForReadPermissionCheck, setModuleOperationsForReadPermissionCheck] = useState({});
    
      useEffect(() => {
        const user = getUser();
          if (user) {
            if (user?.acl_settings) {    
              setModuleOperationsForReadPermissionCheck(JSON.parse(user.acl_settings.module_operations));
            }
          }
      }, []);


    // ✅ Action buttons
    const actionBodyTemplate = (rowData) => (
        <div style={{ display: "flex", gap: "10px" }}>
            {(isSuperAdmin || moduleOperations?.[MODULE_ACL.PBX_MANAGEMENT]?.edit) && (
                <FiEdit
                    style={{ color: "#6c757d", cursor: "pointer", fontSize: "18px" }}
                    onClick={() => navigate(`/create-dialer/${rowData.dialer_id}`)}
                />                
            )}

            {/* {(isSuperAdmin || moduleOperations?.[MODULE_ACL.PBX_MANAGEMENT]?.delete) && (
                <FiTrash2
                    style={{ color: "#dc3545", cursor: "pointer", fontSize: "18px" }}
                    onClick={() => confirmDelete(rowData.dialer_id)}
                />
            )} */}


        </div>
    );

    const [showToast, setShowToast] = useState(false);
        const [toastProps, setToastProps] = useState(null);
        const [buttonDisable, setButtonDisable] = useState(false);
        
            const handleExport = async () => {
   try {
      setButtonDisable(true);

      exportToCSV({
         fileName: "pbx-list",
         data: filteredDialers,
         columns: [
            {
               header: "PBX ID",
               accessor: "dialer_id"
            },
            {
               header: "PBX Name",
               accessor: "dialer_name"
            },
            {
               header: "IP",
               accessor: "ip"
            },
            {
               header: "Port",
               accessor: "port"
            },
            {
               header: "Gateway",
               accessor: (row) =>
                  row.dialerServer?.server_name || "-"
            },
            {
               header: "Trunk",
               accessor: (row) =>
                  row.dialerTrunk?.name || "-"
            },
            {
               header: "Location",
               accessor: (row) =>
                  row.dialerLocation?.location_name || "-"
            },
            {
               header: "Active CLI",
               accessor: "active_cli"
            },
            {
               header: "Active Calls",
               accessor: "active_calls"
            },
            {
               header: "Total Channels",
               accessor: "total_channels"
            },
            {
               header: "Channel Reduction",
               accessor: "channel_reduction"
            },
            {
               header: "CPS Reduction",
               accessor: "cps_reduction"
            }
         ]
      });

   } finally {
      setButtonDisable(false);
   }
};

    if (loading) {
              return <Loader />
           }

    return (
        <div>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <div className="header-title">
                                <h4 className="card-title">PBX Management List</h4>
                            </div>
                            <div style={{display: "flex", alignItems: "flex-start", justifyContent: "flex-start"}}>
                            { (isSuperAdmin || moduleOperations?.[MODULE_ACL.PBX_MANAGEMENT]?.add) && (<button className="btn btn-primary ml-auto" onClick={() => navigate(`/${ROUTES.MANAGE_DIALERS.CREATE}`)}>Create PBX</button>) }
                        {dialers.length > 0 && 
                                                                                                           <Button 
                                                                                                           label="Export Data" 
                                                                                                           onClick={handleExport} 
                                                                                                           className="p-button-active p-button-sm" 
                                                                                                           style={{ marginBottom: '10px', marginLeft: '10px' }} 
                                                                                                           disabled={buttonDisable} 
                                                                                                        >
                                                                                                           &nbsp;
                                                                                                           {buttonDisable && (
                                                                                                              <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                                                                                                           )}
                                                                                                           </Button>
                                                                            }
                                                </div>
                        </Card.Header>

                        <Card.Body className="px-0">
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    padding: "10px",
                                }}
                            >
                                {((isSuperAdmin || moduleOperations?.[MODULE_ACL.PBX_MANAGEMENT]?.delete)) && (
                                    <Button
                                        label="Delete Selected"
                                        className="p-button-danger p-button-sm"
                                        disabled={selectedDialers.length === 0}
                                        onClick={confirmBulkDelete}
                                    /> 
                                )}

                                <Form.Group>
                                    <Form.Control
                                        style={{
                                            marginLeft: "10px",
                                            height: "45px",
                                            border: "1px solid #ced4da",
                                            fontSize: "15px",
                                        }}
                                        placeholder="Search by PBX Name..."
                                        type="text"
                                        value={searchValue}
                                        onChange={(e) => setSearchValue(e.target.value)}
                                    />
                                </Form.Group>

                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                        marginLeft: "20px",
                                    }}
                                >
                                    <span>Show</span>
                                    <Dropdown
                                        value={rows}
                                        options={[
                                            { label: "5", value: 5 },
                                            { label: "10", value: 10 },
                                            { label: "20", value: 20 },
                                            { label: "50", value: 50 },
                                        ]}
                                        onChange={(e) => setRows(e.value)}
                                        style={{ width: "100px", height: "40px", alignItems: "center" }}
                                    />
                                    <span>items</span>
                                </div>
                            </div>

                            {/* DataTable */}
                            <div style={{ overflowX: "auto" }} className="broad-scrollbar">
                                <DataTable
                                    value={filteredDialers}
                                    paginator
                                    rows={rows}
                                    emptyMessage="No PBX found"
                                    tableStyle={{ minWidth: "120rem" }}
                                >
                                    <Column
                                        header={
                                            <Checkbox
                                                checked={
                                                    selectedDialers.length === dialers.length &&
                                                    dialers.length > 0
                                                }
                                                onChange={handleSelectAll}
                                            />
                                        }
                                        headerStyle={{ width: "3rem" }}
                                        body={(rowData) => (
                                            <Checkbox
                                                checked={selectedDialers.includes(rowData.dialer_id)}
                                                onChange={() => handleCheckboxToggle(rowData.dialer_id)}
                                            />
                                        )}
                                    />
                                    <Column field="dialer_id" header="PBX ID" sortable />
                                    <Column field="dialer_name" header="PBX Name" sortable />
                                    <Column field="ip" header="IP" sortable />
                                    <Column field="port" header="Port" sortable />
                                    <Column field="dialerServer.server_name" header="Gateway" />
                                    <Column field="dialerTrunk.name" header="Trunk" />
                                    <Column field="dialerLocation.location_name" header="Dialer Location" />
                                    <Column field="active_cli" header="Active CLI" sortable />
                                    <Column field="active_calls" header="Active Calls" sortable />
                                    <Column field="total_channels" header="Total Channels" sortable />
                                    <Column field="channel_reduction" header="Channel Reduction" sortable />
                                    <Column field="cps_reduction" header="CPS Reduction" sortable />
                                    <Column header="Action" body={actionBodyTemplate} />
                                </DataTable>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <style>
{`
  .broad-scrollbar::-webkit-scrollbar {
    height: 8px; 
  }
`}
</style>

            {/* Delete Confirmation Modal */}
            <Dialog
                header="Confirm Delete"
                visible={deleteModalVisible}
                style={{ width: "25vw" }}
                onHide={() => setDeleteModalVisible(false)}
                footer={
                    <div>
                        <Button
                            label="Cancel"
                            className="p-button-text"
                            onClick={() => setDeleteModalVisible(false)}
                        />
                        <Button
                            label="Delete"
                            className="p-button-danger"
                            onClick={executeDelete}
                        />
                    </div>
                }
            >
                <p>
                    Are you sure you want to delete{" "}
                    {bulkDeleteMode ? "the selected PBX(s)" : "this PBX"}?
                </p>
            </Dialog>
        </div>
    );
};

export default DialerListing;
